import React, { Component } from 'react';
import Select from 'react-select';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { getTheme, getVars } from '../../global/utils';

const SelectWrapper = styled.div`
  margin-bottom: ${props =>
      (props.size === 'xsmall' && getTheme('spacer', 'm')) || getTheme('spacer', 'l')}
    label {
    display: block;
    line-height: 1;
    color: ${getTheme('textColor', 'alt')};
    margin-bottom: ${getTheme('spacer', 'xs')};
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
  }

  .select {
    ${props =>
      props.isDisabled &&
      css`
        pointer-events: none;
        opacity: 0.25;
      `};
  }

  .select__placeholder {
    position: static;
    transform: none;
  }
  .select__control {
    color: ${getTheme('textColor', 'base')};
    background-color: transparent;
    min-height: 0;
    border: 2px solid ${getTheme('black', '_800')};
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
    border-radius: ${props =>
      (props.size === 'xsmall' && getTheme('radius', 'xs')) ||
      (props.size === 'small' && getTheme('radius', 's')) ||
      (props.size === 'medium' && getTheme('radius', 'm')) ||
      (props.size === 'large' && getTheme('radius', 'l')) ||
      getTheme('radius', 'm')};
    min-height: ${props =>
      (props.size === 'xsmall' && getTheme('height', 'xs')) ||
      (props.size === 'small' && getTheme('height', 's')) ||
      (props.size === 'medium' && getTheme('height', 'm')) ||
      (props.size === 'large' && getTheme('height', 'l')) ||
      getTheme('height', 'm')};

    &:hover {
      border-color: ${getTheme('black', '_600')};
    }
    .themeDark & {
      border-color: ${getTheme('black', '_200')};
      color: ${getTheme('textColor', 'baseLight')};
      &:hover {
        border-color: ${getTheme('black', '_400')};
        color: ${getTheme('textColor', 'baseLight')};
      }
      &:active {
        border-color: ${getTheme('black', '_600')};
        color: ${getTheme('textColor', 'baseLight')};
      }
      &:focus {
        box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
      }
    }
  }
  .select__control--is-focused {
    border-color: ${getTheme('black', '_600')};
    box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
  }
  .select__value-container {
    line-height: 1.3;
    padding: 0
      ${props =>
        (props.size === 'xsmall' && getTheme('padding', 'horizontalXS')) ||
        (props.size === 'small' && getTheme('padding', 'horizontalS')) ||
        (props.size === 'medium' && getTheme('padding', 'horizontalM')) ||
        (props.size === 'large' && getTheme('padding', 'horizontalL')) ||
        getTheme('padding', 'horizontalM')};
  }
  .select__single-value {
    .themeDark & {
      color: ${getTheme('textColor', 'baseLight')};
    }
  }
  .select__multi-value__label {
    white-space: normal;
    word-break: break-all;
  }
  .select__indicator-separator {
    display: none;
  }
  .select__dropdown-indicator {
    height: ${props =>
      (props.size === 'xsmall' && getTheme('height', 'xs')) ||
      (props.size === 'small' && getTheme('height', 's')) ||
      (props.size === 'medium' && getTheme('height', 'm')) ||
      (props.size === 'large' && getTheme('height', 'l')) ||
      getTheme('height', 'm')};
    display: flex;
    align-items: center;
    color: ${getTheme('black', '_100')};
    .themeDark & {
      color: ${getTheme('textColor', 'baseLight')};
    }
  }
  .select__menu {
    border: 2px solid ${getTheme('black', '_800')};
    box-shadow: 0 8px 16px ${rgba(getVars('black', '_50'), 0.1)};
    border-radius: ${props =>
      (props.size === 'xsmall' && getTheme('radius', 'xs')) ||
      (props.size === 'small' && getTheme('radius', 's')) ||
      (props.size === 'medium' && getTheme('radius', 'm')) ||
      (props.size === 'large' && getTheme('radius', 'l')) ||
      getTheme('radius', 'm')};
    .themeDark & {
      background-color: ${getVars('bg', 'dark1')};
      border-color: ${getTheme('black', '_200')};
    }
  }
  .select__option {
    cursor: pointer;
    background: transparent;
    color: inherit;
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
    padding: ${props =>
        (props.size === 'xsmall' && getTheme('padding', 'verticalXS')) ||
        (props.size === 'small' && getTheme('padding', 'verticalS')) ||
        (props.size === 'medium' && getTheme('padding', 'verticalM')) ||
        (props.size === 'large' && getTheme('padding', 'verticalL')) ||
        getTheme('padding', 'verticalM')}
      ${props =>
        (props.size === 'xsmall' && getTheme('padding', 'horizontalXS')) ||
        (props.size === 'small' && getTheme('padding', 'horizontalS')) ||
        (props.size === 'medium' && getTheme('padding', 'horizontalM')) ||
        (props.size === 'large' && getTheme('padding', 'horizontalL')) ||
        getTheme('padding', 'horizontalM')};
    &:hover,
    &:focus {
      background: ${getTheme('black', '_950')};
    }

    .themeDark & {
      border-color: ${getTheme('black', '_200')};
      color: ${getTheme('textColor', 'baseLight')};
      &:hover {
        background-color: ${getTheme('black', '_250')};
      }
      &:active {
        border-color: ${getTheme('black', '_350')};
      }
      &:focus {
        background-color: ${getTheme('black', '_250')};
        box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
      }
    }
  }
  .select__option--is-focused {
    background: ${getTheme('black', '_950')};
  }

  .select__option--is-selected {
    background: ${getTheme('active', '_800')};
    color: inherit;
    .themeDark & {
      background: ${getTheme('active', '_200')};
      &:hover {
        background: ${getTheme('active', '_300')};
      }
      &:active {
        background: ${getTheme('active', '_400')};
      }
      &:focus {
        background: ${getTheme('active', '_300')};
      }
    }
  }
  .select__group:not(:first-child) {
    border-top: 1px solid ${getTheme('black', '_800')};
  }
  .select__group-heading {
    font-weight: 700;
    text-transform: uppercase;
    font-size: ${getTheme('fontSize', 'caption')};
    color: ${getTheme('textColor', 'disabled')};
    padding-left: ${props =>
      (props.size === 'xsmall' && getTheme('padding', 'horizontalXS')) ||
      (props.size === 'small' && getTheme('padding', 'horizontalS')) ||
      (props.size === 'medium' && getTheme('padding', 'horizontalM')) ||
      (props.size === 'large' && getTheme('padding', 'horizontalL')) ||
      getTheme('padding', 'horizontalM')};
    padding-right: ${props =>
      (props.size === 'xsmall' && getTheme('padding', 'horizontalXS')) ||
      (props.size === 'small' && getTheme('padding', 'horizontalS')) ||
      (props.size === 'medium' && getTheme('padding', 'horizontalM')) ||
      (props.size === 'large' && getTheme('padding', 'horizontalL')) ||
      getTheme('padding', 'horizontalM')};
  }
  ${props =>
    props.inline &&
    css`
      display: flex;
      align-items: center;

      label {
        display: inline-block;
        margin-right: ${getTheme('spacer', 's')};
        margin-bottom: 0;
      }
      .select {
        flex-grow: 1;
      }
    `};

  ${props =>
    props.autoLength &&
    css`
      .select__control {
        display: inline-flex;
      }
      .select__single-value {
        position: relative;
        top: unset;
        transform: unset;
      }
    `};
  ${props =>
    props.floating &&
    css`
      .select__control {
        border: 0;
        padding: 0;
        height: auto;
        border-radius: 0;
      }
      .select__value-container {
        padding: 0;
      }
      .select__dropdown-indicator {
        margin-left: 0.25em;
        padding: 0;
        width: 0.75em;
      }
      .select__menu {
        min-width: 200px;
        right: 0;
      }
    `};
  ${props =>
    props.alignRight &&
    css`
      .select__menu {
        right: 0;
      }
    `};

  ${props =>
    props.iconBefore &&
    css`
      display: flex;
      align-items: center;
      .icon-before {
        margin-right: ${getTheme('spacer', 's')};
        color: ${getTheme('textColor', 'altLight')};
      }
    `};
`;

class CustomSelect extends Component {
  render() {
    let labelWrapper;
    if (this.props.label) {
      labelWrapper = <label>{this.props.label}</label>;
    }
    return (
      <SelectWrapper
        size={this.props.size}
        inline={this.props.inline}
        autoLength={this.props.autoLength}
        floating={this.props.floating}
        alignRight={this.props.alignRight}
        className={this.props.className}
        iconBefore={this.props.iconBefore}
        isDisabled={this.props.isDisabled}
      >
        <span className="icon-before">{this.props.iconBefore}</span>
        {labelWrapper}
        <Select
          className="select"
          classNamePrefix="select"
          defaultValue={this.props.defaultValue}
          onChange={this.props.handleChange}
          options={this.props.options}
          isDisabled={this.props.isDisabled}
          isSearchable={this.props.isSearchable}
          isMulti={this.props.isMulti}
        />
      </SelectWrapper>
    );
  }
}

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/components/forms/Select.js